<template>
  <div class="carousel" v-if="market.length">
    <div class="slick-container">
      <button class="prev-arrow" @click="$refs.carousel.prev()">
        <svg
          class="icon icon-arrowLeft"
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
        >
          <path d="M0 0h24v24H0z" fill="none"></path>
          <path
            d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
          ></path>
        </svg>
      </button>
      <button class="next-arrow" @click="$refs.carousel.next()">
        <svg
          class="icon icon-arrowLeft"
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
        >
          <path d="M0 0h24v24H0z" fill="none"></path>
          <path
            d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
          ></path>
        </svg>
      </button>
      <VueSlickCarousel v-bind="settings" ref="carousel" style="min-width: 0">
        <div
          v-for="(item, index) in market"
          :key="index"
          class="slide-container"
          style="min-width: 0"
        >
          <div class="coin-info">
            <div class="coin-label">
              <div>
                <TrendChart :data="item.lastWeekData" />
              </div>
              <div>
                <span class="coinunit">
                  {{ $newCoins[item.relatedCoin].code }}
                </span>
                <img
                  class="coin-img"
                  :src="$newCoins[item.relatedCoin].link"
                  alt=""
                  style="margin-left: 8px"
                />
              </div>
            </div>
            <span> {{ $newCoins[item.relatedCoin].persianName }} </span>
            <div class="pricetag">
              <span class="price"> {{ $toLocal(item.lastPrice, 0) }} </span>
              <span class="pricetype"> تومان </span>
            </div>
            <div class="changes">
              <span v-if="item.last24HoursChange > 0" class="success">
                {{ $toLocal(item.last24HoursChange, 2) }}%
              </span>
              <span v-if="item.last24HoursChange == 0"> 0% </span>
              <span v-if="item.last24HoursChange < 0" class="fail">
                {{ $toLocal(Math.abs(item.last24HoursChange), 2) }}%
              </span>
              <inline-svg
                :class="
                  item.last24HoursChange > 0
                    ? 'success'
                    : item.last24HoursChange < 0
                    ? 'fail'
                    : ''
                "
                :src="require('../../../assets/icons/changes.svg')"
              />
            </div>
          </div>
        </div>
      </VueSlickCarousel>
    </div>

    <!-- <Hooper :settings="hoopersSetting">
      <Slide v-for="(item, index) in market" :key="index" class="coin-info">
        <div class="coin-label">
          <div>
            <img
              class="coin-img"
              :src="$newCoins[item.relatedCoin].link"
              alt=""
              style="margin-left: 8px"
            />
            <span class="coinunit">
              {{ $newCoins[item.relatedCoin].code }}
            </span>
          </div>

          <div>
            <TrendChart class="remove2" :data="item.lastWeekData" />
          </div>
        </div>
        <span> {{ $newCoins[item.relatedCoin].persianName }} </span>
        <div class="pricetag">
          <span class="price"> {{ $toLocal(item.lastPrice, 0) }} </span>
          <span class="pricetype"> تومان </span>
        </div>
        <div class="changes">
          <span v-if="item.last24HoursChange > 0" class="success">
            {{ $toLocal(item.last24HoursChange, 2) }}%
          </span>
          <span v-if="item.last24HoursChange <= 0" class="fail">
            {{ $toLocal(Math.abs(item.last24HoursChange), 2) }}%
          </span>
          <inline-svg
            :class="item.last24HoursChange > 0 ? 'success' : 'fail'"
            :src="require('../../../assets/icons/changes.svg')"
          />
        </div>
      </Slide>

      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </Hooper> -->
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import TrendChart from "../../Tools/TrendChart.vue";
// import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
// import "hooper/dist/hooper.css";
export default {
  name: "CoinsCarousel",
  components: {
    // Hooper,
    // Slide,
    // HooperNavigation,
    TrendChart,
    VueSlickCarousel,
  },
  data() {
    return {
      settings: {
        arrows: false,
        dots: false,
        rtl: true,
        slidesToShow: 5,
        // autoplay: true,
        // autoplaySpeed: 2000,
        speed: 300,
        infinite: true,
        rows: 1,
        responsive: [
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 35, 50, 49, 60, 70, 91],
        },
      ],
      chartOptions: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
        },
      },

      market: [],

      hoopersSetting: {
        rtl: true,
        infiniteScroll: true,
        // autoPlay: true,
        autoplaySpeed: 2000,
        itemsToShow: 6,
        centerMode: true,
        breakpoints: {
          1200: {
            itemsToShow: 4,
            centerMode: true,
          },
          800: {
            itemsToShow: 3,
            centerMode: true,
          },
          500: {
            itemsToShow: 2,
          },
          320: {
            itemsToShow: 1,
            centerMode: true,
          },
        },
      },

      // settings: {
      //   rtl: true,
      //   arrows: true,
      //   autoplay: false,
      //   dots: false,
      //   slidesToShow: 6,
      //   slidesToScroll: 1,
      //   autoplaySpeed: 600,
      //   useCSS: true,
      // },
    };
  },
  methods: {
    async lastTrades() {
      const res = await this.$axios.get("/trades/market-info/v2", {
        params: {
          source_coin: "TOMAN",
          weeklyDataIncluded: true,
        },
      });
      this.market = res.content;
    },
  },
  mounted() {
    this.lastTrades();
  },
};
</script>

<style lang="scss" scoped>
.carousel {
  overflow: hidden;
}
.slick-container {
  margin: 0 -8px;
  position: relative;
  overflow: hidden;
}
.next-arrow {
  position: absolute;
  top: 50%;
  right: -1px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transform: translateY(-50%) rotate(180deg);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--light-grey) !important;
  z-index: 20;
}
.prev-arrow {
  position: absolute;
  top: 50%;
  left: -1px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--light-grey) !important;
  z-index: 20;
}
.slide-container {
  padding: 0 8px;
}
::v-deep .hooper-slide {
  min-width: 180px !important;
}
.slider-contaienr {
  width: 100%;
  overflow-x: scroll;
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  border-radius: 12px;
  padding: 12px;
  background: var(--slider-back);
}

.coin-info {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 12px;
  background: var(--box);
  justify-content: flex-start;
  align-items: flex-end;
  border-radius: 12px;
  .coin-label {
    width: 100%;
    display: flex;
    justify-content: space-between;
    column-gap: 10px;
    > div:last-child {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .coin-img {
      width: 30px;
      height: 30px;
    }
    .coinunit {
      align-self: flex-end;
    }
  }
  .pricetag {
    display: flex;
    flex-direction: row;
    column-gap: 10px;
    .pricetype {
      color: var(--grey);
    }
  }
  .changes {
    display: flex;
    flex-direction: row;
    column-gap: 8px;
    align-items: center;
  }
}
</style>
